// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "text-module--base-text-alt--global--e3cc0";
export var baseTextGlobal = "text-module--base-text--global--57e4c";
export var blockSpacing100 = "text-module--block-spacing-100--eccaa";
export var blockSpacing50 = "text-module--block-spacing-50--d1b4e";
export var blockVPadding100 = "text-module--block-v-padding-100--d9b20";
export var blockVPadding50 = "text-module--block-v-padding-50--1015d";
export var body = "text-module--body--47827";
export var bodyContainer = "text-module--bodyContainer--838a1";
export var captionTextGlobal = "text-module--caption-text--global--ef2e6";
export var cmsRenderedContentGlobal = "text-module--cms-rendered-content--global--3247a";
export var container = "text-module--container--5ca54";
export var contentContainer = "text-module--contentContainer--05c96";
export var contentLeftJustified = "text-module--contentLeftJustified--8e987";
export var dark = "text-module--dark--1be05";
export var defaultHSpacingGlobal = "text-module--default-h-spacing--global--60fbd";
export var fadeInAnimation = "text-module--fadeInAnimation--2ebad";
export var fadeInOnLoadGlobal = "text-module--fade-in-on-load--global--9c5c1";
export var fullHeightGlobal = "text-module--full-height--global--eace6";
export var fullHeightOmittingNavGlobal = "text-module--full-height-omitting-nav--global--b1aef";
export var heading = "text-module--heading--8505f";
export var headingTextGlobal = "text-module--heading-text--global--6cab0";
export var ingress = "text-module--ingress--f9eac";
export var ingressTextGlobal = "text-module--ingress-text--global--28f3d";
export var light = "text-module--light--feae1";
export var link = "text-module--link--80ed4";
export var linkColorChangeTransitionGlobal = "text-module--link-color-change-transition--global--8f02c";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "text-module--page-heading-text--global--bbe12";
export var paragraph = "text-module--paragraph--5052f";
export var paragraphTextGlobal = "text-module--paragraph-text--global--ebd9d";
export var subheadingTextGlobal = "text-module--subheading-text--global--60324";
export var textCenter = "text-module--textCenter--0d2e9";
export var textLeft = "text-module--textLeft--e8eab";
export var title = "text-module--title--c3044";